import React, { useEffect } from 'react';
import { useView } from '../../hooks/useView';

type Props = {
  className?: string;
  children: any;
  defaultView: string;
};

function ViewLayout({ className, children, defaultView }: Props) {
  const [current, update] = useView(defaultView);

  useEffect(() => update(defaultView), []);

  const Options = React.Children.map(children, (child: any) =>
    child.type.displayName === 'Option' ? (
      <>{current === child.props.name && child}</>
    ) : null
  );

  return <div className="w-full h-full relative">{Options}</div>;
}

type SCProps = {
  name: string;
  children: any;
};

const Option = (props: SCProps) => props.children;

Option.displayName = 'Option';

ViewLayout.Option = Option;

export default ViewLayout;
